import React from 'react';
import {useTranslation} from 'react-i18next';
import {StyledTagsManagement, StyledTagsManagementSpace} from './StyledTagsManagement';
import PropTypes from 'prop-types';
import TagManager from '../../tabComponents/TagManager';
import {firebaseEvents} from '../../../../../snippets/firebase';
import {tagFamilyConstants} from '../../../../../constants';


const TagsManagement = ({
  edit = true,
  dispatch,
  getCompanyTags,
  addNewCompanyTag,
  deleteCompanyTag,
  ...rest
}) => {
  const [trans] = useTranslation(['settings', 'main']);

  const t = (key) => trans(`tabs.properties.variants.${key}`);

  const getTagManagerProps = (key) => {
    return {
      edit,
      description: t(`${key}.description`),
      inputPlaceholder: t(`${key}.inputPlaceholder`),
      title: t(`${key}.title`),
    }
  }

  return (
    <StyledTagsManagement {...rest}>
      <StyledTagsManagementSpace
        size='large'
        wrap
        {...rest}
      >
        <TagManager
          {...getTagManagerProps('costCenter')}
          logEventName={{
            add: firebaseEvents.COMPANY_SETTINGS_ADD_COST_CENTER_TAG,
            delete: firebaseEvents.COMPANY_SETTINGS_DELETE_COST_CENTER_TAG
          }}
          tagFamily={tagFamilyConstants.COST_CENTER}
        />
        <TagManager
          {...getTagManagerProps('project')}
          logEventName={{
            add: firebaseEvents.COMPANY_SETTINGS_ADD_PROJECT_TAG,
            delete: firebaseEvents.COMPANY_SETTINGS_DELETE_PROJECT_TAG
          }}
          tagFamily={tagFamilyConstants.PROJECT}
        />
        <TagManager
          {...getTagManagerProps('expenseCategory')}
          logEventName={{
            add: firebaseEvents.COMPANY_SETTINGS_ADD_EXPENSE_CATEGORY_TAG,
            delete: firebaseEvents.COMPANY_SETTINGS_DELETE_EXPENSE_CATEGORY_TAG
          }}
          tagFamily={tagFamilyConstants.EXPENSE}
        />
        <TagManager
          {...getTagManagerProps('location')}
          logEventName={{
            add: firebaseEvents.COMPANY_SETTINGS_ADD_LOCATION_TAG,
            delete: firebaseEvents.COMPANY_SETTINGS_DELETE_LOCATION_TAG
          }}
          tagFamily={tagFamilyConstants.LOCATION}
        />
        <TagManager
          {...getTagManagerProps('team')}
          logEventName={{
            add: firebaseEvents.COMPANY_SETTINGS_ADD_TEAM_TAG,
            delete: firebaseEvents.COMPANY_SETTINGS_DELETE_TEAM_TAG
          }}
          tagFamily={tagFamilyConstants.TEAM}
        />
      </StyledTagsManagementSpace>
    </StyledTagsManagement>
  );
}

TagsManagement.propTypes = {
  edit: PropTypes.bool
}

export default TagsManagement;
